import { Suspense } from "react";
import { useTranslation } from "react-i18next";

import type { JobListFilters, JobSortOrder, SortDirection } from "~/features/dbpjkitWorkerJobs/types";
import { DbpjkitWorkerJobPeek } from "./DbpjkitWorkerJobPeek";
import { DbpjkitWorkerJobsSearchForm } from "./DbpjkitWorkerJobsSearchForm";
import { DbpjkitWorkerJobsTable } from "./DbpjkitWorkerJobsTable";

interface DbpjkitWorkerJobsPresenterProps {
  filters: JobListFilters;
  onApplyFilters: (next: JobListFilters) => void;
  onClearFilters: () => void;
  sortOrder: JobSortOrder;
  direction: SortDirection;
  onSortingChange: (order: JobSortOrder, direction: SortDirection) => void;
  pageIndex: number;
  onPageIndexChange: (next: number) => void;
  pageSize: number;
  onPageSizeChange: (next: number) => void;
  isPending: boolean;
  selectedJob: string | null;
  onSelect: (id: string) => void;
  onCloseSelected: () => void;
}

export function DbpjkitWorkerJobsPresenter({
  filters,
  onApplyFilters,
  onClearFilters,
  sortOrder,
  direction,
  onSortingChange,
  pageIndex,
  onPageIndexChange,
  pageSize,
  onPageSizeChange,
  isPending,
  selectedJob,
  onSelect,
  onCloseSelected,
}: DbpjkitWorkerJobsPresenterProps) {
  const { t } = useTranslation();

  return (
    <div className="mx-auto max-w-[var(--content-max)] space-y-5 p-8">
      <h1 className="text-dewey-title capitalize text-fg-1">{t("model.dbpjkitWorkerJob.modelNames")}</h1>

      <DbpjkitWorkerJobsSearchForm filters={filters} onApply={onApplyFilters} onClear={onClearFilters} />

      <Suspense fallback={<TableLoading />}>
        <DbpjkitWorkerJobsTable
          filters={filters}
          sortOrder={sortOrder}
          direction={direction}
          onSortingChange={onSortingChange}
          pageIndex={pageIndex}
          onPageIndexChange={onPageIndexChange}
          pageSize={pageSize}
          onPageSizeChange={onPageSizeChange}
          isPending={isPending}
          onSelect={onSelect}
        />
      </Suspense>

      <DbpjkitWorkerJobPeek id={selectedJob} onClose={onCloseSelected} />
    </div>
  );
}

function TableLoading() {
  return (
    <div className="rounded-[var(--radius-md)] border border-border-default bg-white px-5 py-12 text-center text-[13px] text-fg-3">
      …
    </div>
  );
}
